import styled from "styled-components";

const CustomImage = styled.img.attrs((props) => ({
    src: `${process.env.PUBLIC_URL}/images/${props.imageName}.${props.extension || "png"}`,
    alt: props.altText || props.imageName,
}))`
    width: ${(props) => props.size || props.width || "18px"};
    height: ${(props) => props.size || props.height || "18px"};
    border-radius: ${(props) => props.borderRadius || "0px"};
    visibility: ${(props) => (props.isDisabled ? "hidden" : "visible")};
    cursor: ${(props) => props.cursor || "default"};
`;

export default CustomImage;
